import {
  downloadTemplateByPortfolio,
  downloadTemplateFieldOptions as downloadTemplateFieldOptionsRequest,
  fetchTemplateFieldOptions as fetchTemplateFieldOptionsRequest,
  fetchTemplateByPortfolio,
  replicateTemplateFromPortfolio,
  saveTemplateByType,
  saveTemplateFieldOptions as saveTemplateFieldOptionsRequest,
  validateTemplateFieldOptions as validateTemplateFieldOptionsRequest,
} from "@/app/imports/services";

import {
  SET_PORTFOLIO,
  SET_TEMPLATES_DATA,
  SET_ACTIVE_FIELDS,
  SET_DEFAULTS,
  SET_FIELD_ITEM,
  MOVE_FIELD_ITEM,
  REMOVE_FIELD_ITEM,
  SET_PENDING_TEMPLATE_FIELD_OPTIONS,
  REMOVE_PENDING_TEMPLATE_FIELD_OPTIONS,
  REPLACE_PENDING_TEMPLATE_FIELD_OPTIONS,
} from "./mutation-types";

const actions = {
  async fetchTemplateByPortfolio({ state, commit }) {
    commit(SET_TEMPLATES_DATA, null);
    const templates = await fetchTemplateByPortfolio(state.portfolio?.id);
    commit(SET_TEMPLATES_DATA, templates);
  },
  async saveTemplateByType({ state, commit, dispatch }, type) {
    const templates = await saveTemplateByType(type, state.portfolio?.id, state.activeFields);
    commit(SET_TEMPLATES_DATA, templates);
    await dispatch("setActiveFieldsTemplateByType", type);
  },
  async replicateTemplateFromPortfolio({ state }, { type, source }) {
    const to = state.portfolio.id;
    await replicateTemplateFromPortfolio(type, source, to);
  },
  async downloadTemplateByType({ state }, type) {
    const portfolio = state.portfolio.id;
    const response = await downloadTemplateByPortfolio(type, portfolio);
    return response;
  },
  async downloadTemplateFieldOptions({ state }, fieldName) {
    return downloadTemplateFieldOptionsRequest(state.portfolio?.id, fieldName);
  },
  async fetchTemplateFieldOptions({ state }, fieldName) {
    return fetchTemplateFieldOptionsRequest(state.portfolio?.id, fieldName);
  },
  async validateTemplateFieldOptions({ state }, { fieldName, file }) {
    return validateTemplateFieldOptionsRequest(state.portfolio?.id, fieldName, file);
  },
  setPendingTemplateFieldOptions({ commit }, payload) {
    commit(SET_PENDING_TEMPLATE_FIELD_OPTIONS, payload);
  },
  removePendingTemplateFieldOptions({ commit }, fieldName) {
    commit(REMOVE_PENDING_TEMPLATE_FIELD_OPTIONS, fieldName);
  },
  replacePendingTemplateFieldOptions({ commit }, pendingOptions) {
    commit(REPLACE_PENDING_TEMPLATE_FIELD_OPTIONS, pendingOptions);
  },
  async saveTemplateFieldOptions({ state, getters, commit }) {
    const response = await saveTemplateFieldOptionsRequest(
      state.portfolio?.id,
      getters.getPendingTemplateFieldOptionsForActiveFields,
    );
    const savedFields = response?.saved || {};

    if (state.templates?.client_template) {
      commit(SET_TEMPLATES_DATA, {
        ...state.templates,
        client_template: state.templates.client_template.map((field) => {
          const savedField = savedFields[field.name];

          return savedField
            ? {
                ...field,
                options_count: savedField.count,
                options_source: savedField.source,
                options_file_name: savedField.file_name,
              }
            : field;
        }),
      });
    }

    commit(REPLACE_PENDING_TEMPLATE_FIELD_OPTIONS, {});
    return response;
  },
  setActiveFieldsTemplateByType({ state, commit }, type) {
    let activeFields = state.templates.account_template;
    if (type == "client") activeFields = state.templates.client_template;
    commit(SET_ACTIVE_FIELDS, activeFields);
    commit(SET_DEFAULTS, type);
  },
  updateTemplateActiveFields({ state, getters, commit }, fields) {
    // const activeFieldsWithDefaults = [...state.defaults, ...fields];

    const activeFieldsDefaults = getters['getActiveTemplateFieldsOrdered'].filter(obj1 => 
      state.defaults.some(obj2 => obj2.name === obj1.name)
    );
    const activeFieldsWithDefaults = [
      ...activeFieldsDefaults.filter(itemDefault =>
        !fields.some(item => itemDefault.name === item.name)),
      ...fields,
    ];
    commit(SET_ACTIVE_FIELDS, activeFieldsWithDefaults);
  },
  setTemplatePortfolio({ commit }, portfolio) {
    commit(SET_PORTFOLIO, portfolio);
  },
  setTemplateFieldItem({ commit }, field) {
    commit(SET_FIELD_ITEM, field);
  },
  moveTemplateFieldItem({ commit }, { from, to }) {
    commit(MOVE_FIELD_ITEM, { from, to });
  },
  removeTemplateFieldItem({ commit }, field) {
    commit(REMOVE_FIELD_ITEM, field);
  },
  clearTemplatePortfolio({ state }) {
    state.portfolio = null;
  },
};

export default actions;
